// extracted by mini-css-extract-plugin
export default {"header":"styles_header__X7Yk+","title":"styles_title__XdcGX","subtitle":"styles_subtitle__22KPK"};